import { useState } from "react";
import type { FaqItem } from "@/mocks/faq";

type FaqAccordionProps = {
  items: FaqItem[];
  defaultOpen?: number;
};

export default function FaqAccordion({ items, defaultOpen = 0 }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(defaultOpen);

  return (
    <div className="divide-y divide-background-200 border-y border-background-200">
      {items.map((item, index) => {
        const isOpen = openIndex === index;
        return (
          <div key={item.question}>
            <button
              type="button"
              onClick={() => setOpenIndex(isOpen ? null : index)}
              aria-expanded={isOpen}
              className="flex w-full cursor-pointer items-start justify-between gap-4 py-5 text-left transition-colors hover:text-primary-600"
            >
              <span className="flex items-start gap-3">
                <span className="mt-0.5 font-heading text-sm font-semibold text-primary-500">
                  {String(index + 1).padStart(2, "0")}
                </span>
                <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
                  {item.question}
                </span>
              </span>
              <span
                className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full border transition-all ${
                  isOpen
                    ? "rotate-180 border-primary-300 bg-primary-500 text-background-50"
                    : "border-background-300 text-foreground-500"
                }`}
              >
                <i className="ri-arrow-down-s-line text-base"></i>
              </span>
            </button>
            <div
              className={`grid overflow-hidden transition-all duration-300 ${
                isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
              }`}
            >
              <div className="overflow-hidden">
                <p className="pb-6 pl-9 pr-8 text-sm leading-7 text-foreground-600 md:text-[15px]">
                  {item.answer}
                </p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}